import React, { FC } from "react"
import { PrivateRouteProps } from "../types"
import { Navigate } from "react-router-dom"
import MasterTemplate from "../components/layouts/master/MasterTemplate"
import { connect } from "react-redux"
import { RootState } from "../store"
import NotFound from "../components/NotFound"
import { DEFAULT_ROUTE, DEFAULT_ROUTES } from "../constants"
import MobileAppRedirect from "../components/MobileAppRedirect"
import { lang } from "../constants/languages"

const isMobileDevice = (): boolean => {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera || ""
  return /iPad|iPhone|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)
}

const PrivateRoute: FC<PrivateRouteProps> = (props) => {
  const params = new URLSearchParams(window.location.search)
  const releaseSubmission = params.get("release_submission")
  if (releaseSubmission) {
    localStorage.setItem("releaseSubmission", "1")
  }

  if (
    (isMobileDevice() || window.innerWidth < 1024) &&
    !window.location.host.includes("localhost") &&
    !window.location.pathname.includes("smart-link") &&
    !window.location.pathname.includes("invitation") &&
    !window.location.pathname.includes("artist")
  ) {
    // Show app store redirect for mobile devices or small screens (except smart-link, invitation, artist)
    return <MobileAppRedirect />
  }

  // For private routes, check authentication first before any redirect
  if (props.private && !props.loggedIn) {
    return <Navigate to="/login" />
  }

  // Handle redirect for authenticated users
  if (props.redirect) {
    return <Navigate to={props.redirect} />
  }

  const userAdminPermissionList = props.adminPermissions?.split(",") || []
  // Permission check for user roles (skip check if roleId is 0/not loaded yet)
  const notPermittedRoles =
    props.userRole !== 0 && props.permittedRoles?.length && !props.permittedRoles.includes(props.userRole)
  const notPermittedAdminPermission =
    props.permittedAdminPermissons?.length &&
    !props.permittedAdminPermissons.some((adminPermission) => userAdminPermissionList.includes(adminPermission))
  if (props.loggedIn && props.userRole !== 0 && (notPermittedRoles || notPermittedAdminPermission)) {
    return (
      <NotFound
        title={lang.not_found.private_route.title}
        description={lang.not_found.private_route.desc}
        buttonText={lang.not_found.private_route.button}
        buttonLink={DEFAULT_ROUTE}
        imageWidth={350}
        titleSize={36}
        descriptionSize={20}
      />
    )
  }

  // Redirect after logging in.
  if (!props.private && props.loggedIn && !props.overrideDefaultRoute) {
    return <Navigate to={DEFAULT_ROUTES[props.userRole]} />
  }

  // Let user go if not private or already logged in.
  if (!props.private || props.loggedIn) {
    return <MasterTemplate>{props.children}</MasterTemplate>
  }

  // Otherwise redirect to log in.
  return <Navigate to="/login" />
}
const mapStateToProps = (state: RootState) => {
  return {
    loggedIn: state.auth.loggedIn,
    userRole: state.auth.user.roleId,
    adminPermissions: state.auth.user.adminPermissions
  }
}
export default connect(mapStateToProps, {})(PrivateRoute)
